import { FIELD_REFERENCES, TABLE_FIELDS } from '../constants'

export function getInitialFormData(table) {
    const fields = TABLE_FIELDS[table] || {}

    return Object.fromEntries(
        Object.entries(fields).map(([field, type]) => [
            field,
            type === 'checkbox' ? false : '',
        ])
    )
}

export function getReferenceTables(table) {
    const fields = TABLE_FIELDS[table] || {}

    return [
        ...new Set(
            Object.keys(fields)
                .map((field) => FIELD_REFERENCES[field])
                .filter(Boolean)
        ),
    ]
}

export function getItemId(item) {
    if (!item) return ''

    const idKey = Object.keys(item).find(
        (key) => key === 'id' || key.endsWith('_id')
    )

    return idKey ? item[idKey] : ''
}

export function getOptionLabel(item) {
    if (!item) return 'Без названия'

    const itemId = getItemId(item)
    const fullName = `${item.lastname || ''} ${item.firstname || ''} ${
        item.patronymic || ''
    }`.trim()

    if (fullName) return `${fullName} — ID ${itemId}`
    if (item.name) return `${item.name} — ID ${itemId}`
    if (item.address) return `${item.address} — ID ${itemId}`
    if (item.abbreviation) return `${item.abbreviation} — ID ${itemId}`
    if (item.practice_module) return `${item.practice_module} — ID ${itemId}`
    if (item.course) return `${item.course} — ID ${itemId}`
    if (item.start_time && item.end_time) {
        return `${item.start_time} - ${item.end_time} — ID ${itemId}`
    }
    if (item.subject_id || item.teacher_id) {
        return `Предмет ${item.subject_id || '—'}, преподаватель ${
            item.teacher_id || '—'
        } — ID ${itemId}`
    }

    return `ID ${itemId}`
}

export function getTableColumns(tableData) {
    return Array.from(
        new Set(tableData.flatMap((item) => Object.keys(item || {})))
    )
}

export function normalizeFieldValue(value, type) {
    if (type === 'checkbox') return value
    if (type === 'number') return value === '' ? '' : Number(value)
    return value
}
